module.exports = __webpack_public_path__ + "media/images/athletes/1611-8fcfd7dfa266bb0076d73a81b1742fd8.png";